import type { ColumnType } from 'antd/es/table/interface'
import { useCallback } from 'react'

import { useColumnCustomSearchFilter } from './useColumnCustomSearchFilter'

/**
 * client-side Ant Table columns filter by string.
 */
export function useColumnSearchFilter<T>() {
  const { getCustomSearchFilter } = useColumnCustomSearchFilter<T>()

  const getSearchFilter = useCallback(
    (dataIndex: keyof T, placeholder?: string): ColumnType<T> => {
      const onFilter = (value: string, record: T) =>
        !!record[dataIndex]
          ?.toString()
          .toLowerCase()
          .includes(value.toLowerCase())

      return getCustomSearchFilter(onFilter, placeholder)
    },
    [getCustomSearchFilter]
  )

  return { getSearchFilter }
}
